import React from "react";
import { Col, Row, Button } from "antd";
import "./footer.scss";
import { CALENDLY_LINK } from "../../../env";
import { trackCta } from "../../../analytics";
import { buildRegisterUrl } from "../../../utils/registerRedirect";

const CURRENT_YEAR = new Date().getFullYear();

const FOOTER_HEADING_LIST = [
  '3D Services',
  'Company',
  'Support'
]

const FOOTER_PAGE_LIST = [
  {
    'page': 'AI Images',
    'url': '/ai-creator',
    'type': '3D Services'
  },
  {
    'page': 'About',
    'url': '/about-us',
    'type': 'Company'
  },
  {
    'page': 'Schedule a demo',
    'url': CALENDLY_LINK,
    'type': 'Support'
  },
  {
    'page': 'Pricing',
    'url': '/pricing',
    'type': '3D Services'
  },
  {
    'page': 'Artist Application',
    'url': 'https://app.all3d.ai/register_as_artist',
    'type': 'Company'
  },
  {
    'page': 'Contact Us',
    'url': '/contact-us',
    'type': 'Support'
  },
  {
    'page': 'How it Works',
    'url': '/how-all3d-works',
    'type': '3D Services'
  },
  {
    'page': 'Terms of Service',
    'url': '/terms',
    'type': 'Company'
  },
  {
    'page': 'FAQs',
    'url': '/faqs',
    'type': 'Support'
  },
  {
    'page': 'ALL3D Store',
    'url': '/store',
    'type': '3D Services'
  },
  {
    'page': 'Privacy Policy',
    'url': '/privacy',
    'type': 'Company'
  }
]

function Footer() {
  return (
    <>
      <WebVersion />
      <MobileVersion />
    </>
  );
}

function WebVersion() {
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=footer`;

  return (
    <footer className="d-none d-lg-block">
      <Row className="footer-bg">
        <Col span={12}>
          <h2 className="manrope f-24 w-700 white">Sign up to try ALL3D for free</h2>
          <p className="manrope f-14 white w-500">Try our user-friendly 3D platform for 14 days.</p>
          <Button data-attr="footer-start-free-trial" className="modal-okay square font-16 center-btn width-fit mt-16 mb-36"
            onClick={() => {
              trackCta('free_trial_click', {
                section: 'footer',
                placement: 'desktop',
                button: 'get_started_for_free',
              });
              window.open(buildRegisterUrl(redirectPath), "_blank");
            }}>
            Start a free trial today
          </Button>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={24} className="footer-grid">
              {FOOTER_HEADING_LIST.map((heading) => (
                <h4 className="manrope f-18 w-700 white">{heading}</h4>
              ))}
              {FOOTER_PAGE_LIST.map((page) => {
                const isContactUs = page.page === "Contact Us";
                const url = isContactUs
                  ? `${page.url}?contact-footer=true`
                  : page.url;

                return (
                  <a
                    key={page.page}
                    data-attr={`footer-link-${page.page.toLowerCase().replace(/\s+/g, '-')}`}
                    className="manrope f-14 w-500 white"
                    href={url}
                  >
                    {page.page}
                    {page.page === "AI Creator" && (
                      <span className="beta-tag">BETA</span>
                    )}
                  </a>
                );
              })}
            </Col>
          </Row>
        </Col>
        <Row className="justify-space-between w-100 align-end">
          <Col span={12}>
            {/* <img src='/footer/app-store-btn.svg' className="mb-16" onClick={() => {
              window.location.href = "https://apps.apple.com/app/all3d-scanning-app/id1513820542";
            }} /> */}

            <Col span={8} className="justify-space-between">
              <a href="https://www.linkedin.com/company/all3d-ai/about/" target="_blank" rel="noopener noreferrer" aria-label="Visit our LinkedIn page">
                <img src='/footer/linkedin.svg' alt="LinkedIn" className="cursor pointer" />
              </a>
              <a href="https://www.facebook.com/all3dai/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Facebook page">
                <img src='/footer/facebook.svg' alt="Facebook" className="cursor pointer" />
              </a>
              <a href="https://www.instagram.com/all3d.ai/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Instagram page">
                <img src='/footer/instagram.svg' alt="Instagram" className="cursor pointer" />
              </a>
              <a href="https://twitter.com/all3d_ai" target="_blank" rel="noopener noreferrer" aria-label="Visit our X page">
                <img src='/footer/x.svg' alt="X" className="cursor pointer" />
              </a>
            </Col>
            <p className="manrope f-14 w-500 white mt-16 mb-0">© Copyright ALL3D {CURRENT_YEAR} All Rights Reserved.</p>
          </Col>
          <Col span={12} className="justify-in-end flex-imp">
            <a href="https://all3d.ai" aria-label="Go to ALL3D homepage">
              <img alt="ALL3D Logo"
                className="cursor pointer"
                src="/footer/new-all3d-white.svg" />
            </a>
          </Col>
        </Row>
      </Row>
    </footer>
  );
}

function MobileVersion() {
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=footer`;

  return (
    <footer className="footer-bg d-lg-none">
      <Row className="w-100">
        <Col span={24} className="justify-in-center flex-imp direction-flex coll">
          <h2 className="manrope f-24 w-700 white">Sign up to try ALL3D for free</h2>
          <p className="manrope f-14 white w-500">Try our user-friendly 3D platform for 14 days.</p>
          <Button data-attr="footer-start-free-trial-mobile" className="modal-okay square font-16 center-btn width-fit mt-16 mb-30" onClick={() => {
            trackCta('free_trial_click', {
              section: 'footer',
              placement: 'mobile',
              button: 'get_started_for_free',
            });
            window.open(buildRegisterUrl(redirectPath), "_blank");
          }}>
            Start a free trial today
          </Button>
        </Col>
        <Col span={24} className="justify-in-center flex-imp direction-flex coll w-100">
          {FOOTER_HEADING_LIST.map((heading) => (
            <>
              <h4 className="manrope f-18 w-700 white mb-10 mt-10">
                {heading}
              </h4>
              {FOOTER_PAGE_LIST.map((page) => (
                page.type === heading &&
                <a className="manrope f-14 w-500 white mb-8"
                  data-attr={`footer-link-${page.page.toLowerCase().replace(/\s+/g, '-')}-mobile`}
                  href={page.page === "Contact Us" ? `${page.url}?contact-footer=true` : page.url}
                  key={page.page}>
                  {page.page}
                  {page.page == 'AI Creator' && <span className="beta-tag">BETA</span>}
                </a>
              ))}
            </>
          ))}
        </Col>
        <Col span={24} className="justify-in-center flex-imp direction-flex coll w-100 mt-40" >
          {/* <img src='/footer/app-store-btn.svg' className="mb-16" onClick={() => {
            window.location.href = "https://apps.apple.com/app/all3d-scanning-app/id1513820542";
          }} /> */}
          <Col span={12} className="justify-space-between w-100">
            <a href="https://www.linkedin.com/company/all3d-ai/about/" target="_blank" rel="noopener noreferrer" aria-label="Visit our LinkedIn page">
              <img src='/footer/linkedin.svg' alt="LinkedIn" />
            </a>
            <a href="https://www.facebook.com/all3dai/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Facebook page">
              <img src='/footer/facebook.svg' alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/all3d.ai/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Instagram page">
              <img src='/footer/instagram.svg' alt="Instagram" />
            </a>
            <a href="https://twitter.com/all3d_ai" target="_blank" rel="noopener noreferrer" aria-label="Visit our X page">
              <img src='/footer/x.svg' alt="X" />
            </a>
          </Col>
          <p className="manrope f-14 w-500 white mt-16 mb-16">© Copyright ALL3D {CURRENT_YEAR} All Rights Reserved.</p>
          <a href="https://all3d.ai" aria-label="Go to ALL3D homepage">
            <img alt="ALL3D Logo" src="/footer/new-all3d-white.svg" />
          </a>
        </Col>
      </Row>
    </footer>
  );
}

export default Footer;
